import { FC } from "react"
import styles from "./QuotationContextMenu.module.scss"

export type TContextMenuItem = {
	key: string
	label: string
	/** Right-aligned shortcut hint, e.g. "⌘C". */
	shortcut?: string
	disabled?: boolean
	onSelect: () => void
}

type Props = {
	items: TContextMenuItem[]
}

/**
 * Dark right-click context menu for the quotation viewer (Figma "Menubar" 16416:472978).
 * Presentational only — positioning + dismissal are owned by the host (useQuotationViewer),
 * which renders this into the shadow-DOM overlay at the cursor. REQ-368 uses it for the
 * single "Copy" item; REQ-367 will extend the same component with Duplicate / Connect /
 * Delete and separators.
 */
export const QuotationContextMenu: FC<Props> = ({ items }) => {
	return (
		<div className={styles.menu} role="menu">
			{items.map((item) => (
				<button
					key={item.key}
					type="button"
					role="menuitem"
					className={styles.item}
					disabled={item.disabled}
					onClick={item.onSelect}
				>
					<span className={styles.label}>{item.label}</span>
					{item.shortcut ? <span className={styles.shortcut}>{item.shortcut}</span> : null}
				</button>
			))}
		</div>
	)
}
